import React from "react";
import "./css/profileCompleteModal.css";

const sectionCompletionMap = {
  basic_details: 10,
  horoscope_details: 10,
  contact_details: 10,
  religion_details: 5,
  location_details: 10,
  family_details: 10,
  educational_details: 10,
  professional_details: 15,
  hobbies_interests: 5,
  partner_basic: 8,
  partner_location: 3,
  partner_education: 2,
  partner_other: 2,
};

export default function CompletionModal({ setShowCompletionModal }) {
  return (
    <div className="modal-overlay">
      <div className="modal-box">

        <h4>Profile Completion</h4>
        <hr />

        <ul className="completion-list">
          {Object.entries(sectionCompletionMap).map(([key, value]) => (
            <li key={key}>
              <span style={{ textTransform: "capitalize" }}>{key.replaceAll("_", " ")}</span>
              <b>{value}%</b>
            </li>
          ))}
        </ul>
          <div className="d-flex justify-content-center">
            <button className="btn btn-small btn-default" onClick={() => setShowCompletionModal(false)}>
            Close
            </button>
        </div>

      </div>
    </div>
  );
}